import { BotDetectionService } from '@naturalcycles/js-lib'
import { env } from '@src/environments/environment'

// window check is needed when this code is ran without a client, eg in capacitor.config.ts
export const isE2e = typeof window !== 'undefined' && !!localStorage.getItem('e2e')

export const botDetectionService = new BotDetectionService({
  enabled: !env.test, // disable in unit tests, so it doesn't scream
  memoizeResults: true,
  treatCDPAsBotReason: true,
})
